import React from 'react';
import defaultStyles from './index.module.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  dynamicStyle?: React.CSSProperties;
  staticStyle?: Record<string, string>;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  dynamicStyle,
  staticStyle = defaultStyles
}) => {
  if (!isOpen) return null;
  return (
    <div className={staticStyle.modalBackdrop} onClick={onClose}>
      <div
        className={staticStyle.modalContent}
        style={dynamicStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
